export default __webpack_public_path__ + "static/media/apple-logo-phone.78e746e8.svg";